/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { AssociationType } from 'app/shared/model/enumerations/association-type.model';

export interface IDoctorDiaglabAssociation {
  id?: string;
  joiningDate?: number;
  leavingDate?: number | null;
  dutyStartTime?: string | null;
  dutyEndTime?: string | null;
  permanent?: boolean | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  association?: keyof typeof AssociationType | null;
  doctor?: IDoctor;
  lab?: IDiagLab;
}

export const defaultValue: Readonly<IDoctorDiaglabAssociation> = {
  permanent: false,
  active: false,
};
